import React from 'react'
import DarkMode from './DarkMode'
import Language from './Language'
import Users from './User'
import { UL } from '../../../AbstractElements'
import WalletShortcut from './WalletShortcut'

// col, а не col-6: горизонтальное меню из шапки убрано, и с фиксированной
// половиной ширины правый блок прижимался к логотипу вместо правого края.
const RightHeader = ({ isAssistantCollapsed, setIsAssistantCollapsed }) => {
  return (
    <div className="simple-list nav-right col pull-right right-header p-0">
    <UL attrUL={{className:"  nav-menus"}} >
    {/* Поиск шаблона убран: он ищет по демо-страницам темы, а не по кабинету.
        «Миры» переехали в левую часть шапки, к остальным разделам — здесь
        оставалась вторая такая же иконка. */}
    <DarkMode/>
        {/* Значок ассистента убран из шапки: он потерялся среди иконок
            темы. Помощница теперь живёт отдельной кнопкой в правом
            нижнем углу — см. FairyButton. */}
     <Language/>
    <WalletShortcut />
    <Users/>
    </UL>
  </div>
  )
}

export default RightHeader